<template>
    <header class="about_header">
         <h2 :style="$vuetify.rtl ? {right: '10%'} :{left:'10%'}" class="text-capitalize white--text">{{$t("aboutUs.about")}}</h2>
         <div class="overlay"></div>
    </header>
</template>

<script>
export default {
    name:'about_header'
}
</script>

<style lang="scss">
    .about_header{
        background-image: url('../../assets/spencer-davis-xyilWXHQMLo-unsplash.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        height: 250px;
        background-position: center;
        position: relative;
        h2{
            position: absolute;
            bottom: 10%;
            left: 8%;
            z-index: 2;
            font-size: 20pt;
        }
        .overlay{
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: #000;
            opacity: .4;
            z-index: 1;
        }
    }
</style>